/** Содержимое секции паспорта проекта и экспликации помещений. */
import { UIKit } from "@/shared/ui";
import { DEFAULT_PROJECT_NAME, useProjectStore } from "@/shared/store";
import { formatArea } from "@/shared/lib/geometry";
import { effectiveWallGraph } from "@/shared/plan";
import { useEditorStore } from "@/widgets/editor";
import { detectRooms } from "@/widgets/plan";
import { useSaveProjectMetadata } from "@/widgets/plan-storage";

export const ProjectPanelContent = ({ projectId }: { projectId: string | null }) => {
	const projectName = useProjectStore((state) => state.project.name);
	const projectDescription = useProjectStore((state) => state.project.description);
	const graph = useProjectStore((state) => state.project.layers.walls);
	const isReadOnly = useEditorStore((state) => state.isReadOnly);
	const setName = useProjectStore((state) => state.setName);
	const setDescription = useProjectStore((state) => state.setDescription);
	const saveMetadata = useSaveProjectMetadata(projectId);
	const rooms = detectRooms(effectiveWallGraph(graph));

	return (
		<div className="contents">
			<UIKit.Text className="text-sm font-semibold tracking-label text-ink uppercase">
				Проект
			</UIKit.Text>
			<UIKit.TextInput
				label="Название"
				className="mt-1 w-full px-2 py-1.5 text-sm text-ink"
				value={projectName}
				disabled={isReadOnly}
				onChange={setName}
				onBlur={(event) => {
					if (isReadOnly) return;
					if (event.target.value.trim() === "") setName(DEFAULT_PROJECT_NAME);
					void saveMetadata();
				}}
			/>
			<UIKit.Textarea
				label="Описание"
				className="mt-1 min-h-16 px-2 py-1.5 text-sm leading-normal text-ink"
				placeholder="Адрес, заказчик, заметки"
				value={projectDescription}
				disabled={isReadOnly}
				onChange={setDescription}
				onBlur={() => {
					if (isReadOnly) return;
					void saveMetadata();
				}}
			/>
			<UIKit.Text className="mt-4 text-sm font-semibold tracking-label text-ink uppercase">
				Помещения
			</UIKit.Text>
			{rooms.length === 0 ? (
				<UIKit.Text className="mt-2 text-xs leading-normal text-ink">
					Замкните контур стен — площади помещений посчитаются автоматически.
				</UIKit.Text>
			) : (
				<ul className="mt-2 flex list-none flex-col gap-0.5 p-0">
					{rooms.map((room, index) => (
						<li
							key={room.id}
							className="flex justify-between rounded-md bg-slate-50 px-2.5 py-1.75 text-sm"
						>
							<UIKit.Text as="span">Помещение {index + 1}</UIKit.Text>
							<UIKit.Text as="span" className="text-ink tabular-nums">
								{formatArea(room.area)}
							</UIKit.Text>
						</li>
					))}
				</ul>
			)}
		</div>
	);
};
